import { Navigate } from "react-router-dom"

const AdminProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem("userToken") !== null
  const isAdmin = localStorage.getItem("isAdmin") === "true"

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />
  }

  // If user is not admin, redirect to regular dashboard
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />
  }

  return element
}

export default AdminProtectedRoute

